export enum WealthPortfolioTabsIndexes {
  Performance = 0,
  Allocation = 1,
  Orders = 2,
  About = 3
}

export enum WealthPortfolioTabs {
  Performance = 'performance',
  Allocation = 'allocation',
  Orders = 'orders',
  About = 'about'
}
